import classes from "../../indenttrack.module.css";
import { useState } from "react";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import "react-accessible-accordion/dist/fancy-example.css";
import Modal from "../../../Shared/PopupModal/PopupModal";
import { toast } from "react-toastify";
import axios from "../../../../Axios";
import { Urls } from "../../../../Urls";
import { downloadFileToLocal } from "../../../../utils/downloadFile";
import ReactTooltip from "react-tooltip";

const DeleteConfirmationContent = ({ onClose, onConfirm }) => {
  const [remarks, setRemarks] = useState("");

  return (
    <div className="text-center">
      <h6>Are you sure you want to delete?</h6>
      <div className="mt-2" style={{ textAlign: "left" }}>
        <label style={{ fontSize: "14px" }}>
          Remarks{" "}
          <span className="text-muted" style={{ fontSize: "12px" }}>
            (optional)
          </span>
        </label>
        <input
          type="text"
          className="form-control"
          placeholder="Enter remarks"
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
        />
      </div>
      <div
        className="d-flex justify-content-center mt-3"
        style={{ gap: "10px" }}
      >
        <button
          className="btn btn-success btn-sm"
          onClick={() => {
            onConfirm(remarks);
            onClose();
          }}
        >
          Yes
        </button>
        <button className="btn btn-danger btn-sm" onClick={onClose}>
          No
        </button>
      </div>
    </div>
  );
};

/**
 * Displays and manages uploaded files in a card format.
 * @param {Object} props - Properties for the component.
 * @param {string} props.name - The name of the file type (e.g., "POD", "Invoice").
 * @param {Array} props.files - Array of file objects to display.
 * @param {Function} props.uploadFiles - Function to handle file uploads.
 * @param {string} props.indent_id_sub - The sub-indent ID.
 * @param {string} props.indentId - The indent ID.
 * @param {string} props.type - The type of files being displayed ("pod" or "invoice").
 * @param {Function} props.getData - Function to fetch updated data.
 * @returns {JSX.Element} - The rendered component.
 */
const FileUploadCard = ({
  name,
  files,
  uploadFiles,
  indent_id_sub,
  indentId,
  type,
  getData,
  indent,
  show,
  onDelete,
  disableUpload: disableUploadProp,
}) => {
  const isStatusReached = indent?.vehicle?.status_track?.some(
    (status) => status?.value === "reached",
  );

  const isPodOrInvoice = type === "pod" || type === "invoice";
  const disableUpload =
    (isPodOrInvoice && !isStatusReached) || type === "lr" || disableUploadProp;

  /**
   * Opens the file URL in a new window.
   * @param {string} url - The URL of the file to be opened.
   */
  const handleFileDownload = (file) => {
    // window.open(url?.split("?")[0]);
    downloadFileToLocal(file.fileUrl?.split("?")[0], file?.fileName);
  };

  /**
   * Removes a file from the indent and updates the state.
   * @param {Object} file - The file object to be removed.
   * @param {string} indent_id_sub - The sub-indent ID.
   * @param {string} indentId - The indent ID.
   * @param {Function} getData - Function to fetch updated data.
   */
  const removeFile = (file, remarks) => {
    onDelete(file, type, remarks);
  };

  /**
   * Displays a preview of the file based on its type.
   * @param {Object} file - The file object to be previewed.
   * @returns {JSX.Element} - The rendered file preview.
   */
  const ViewFile = ({ file }) => {
    const [numPages, setNumPages] = useState(null);

    function onDocumentLoadSuccess({ numPages }) {
      setNumPages(numPages);
    }

    if (!file || !file.fileName) {
      return null;
    }

    const fileName = file.fileName.split("?")[0];
    const fileExtension = fileName.split(".").pop().toLowerCase();
    const allowedImageExtensions = ["jpg", "jpeg", "png", "bmp"];

    const isImageFile = allowedImageExtensions.includes(fileExtension);
    const isPDf = fileExtension === "pdf";
    return (
      <div
        className="row col-md-12 my-2"
        style={{ maxHeight: "80vh", overflow: "auto" }}
        //style={!isImageFile ? { height: "400px", overflowY: "auto" } : {}}
      >
        <span id="Download_btn" data-tip data-for="Download_btn">
          <button
            className="btn btn-sm d-flex align-items-center"
            style={{
              backgroundColor: "#6c757d", // gray
              color: "#fff",
              border: "none",
              gap: "6px",
              padding: "6px 10px",
            }}
            onClick={() => handleFileDownload(file)}
          >
            <i className="fa fa-download" aria-hidden="true"></i>
            Download File
          </button>
        </span>
        <ReactTooltip
          id="Download_btn"
          place="bottom"
          effect="float"
          backgroundColor="#393185 !important"
        >
          <div>Download File</div>
        </ReactTooltip>

        {isImageFile ? (
          <img
            allowfullScreen
            src={file.fileUrl.split("?")[0]}
            // width="100%"
            // height="auto"
            // width={"auto"}
            style={{
              display: "inline-block",
              maxWidth: "none",
              height: "auto",
            }}
            alt="img"
          />
        ) : isPDf ? (
          <Document
            file={file && file.fileUrl ? file.fileUrl.split("?")[0] : ""}
            onLoadSuccess={onDocumentLoadSuccess}
          >
            {Array.from(new Array(numPages), (el, index) => (
              <Page key={`page_${index + 1}`} pageNumber={index + 1} />
            ))}
          </Document>
        ) : (
          <div className="text-center mt-1">
            <p style={{ fontSize: "14px", color: "#686666" }}>
              Preview not supported for this file type
            </p>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="w-100">
      <div className={classes["cursor"]}>
        {/* <div className={`${classes["uploadArea"]} d-flex flex-column`}> */}
        <div
          className={`${
            disableUpload || type === "lr"
              ? classes["uploadArea-disable"]
              : classes["uploadArea"]
          } d-flex flex-column justify-content-center align-items-center`}
          style={{ height: "70px" }}
        >
          <center>
            {disableUpload ? (
              <>
                {/* Disabled State */}
                <div className="d-flex align-items-center flex-column mx-3">
                  <i
                    className="fa fa-ban px-2 text-danger"
                    aria-hidden="true"
                  ></i>
                  <small
                    className="text-muted font-weight-bold"
                    style={{ fontSize: "11px" }}
                  >
                    {type === "lr" || disableUploadProp
                      ? `${type.toUpperCase()} upload disabled`
                      : `Update vehicle status to 'reached' to upload ${type.toUpperCase()}`}
                  </small>
                </div>
              </>
            ) : (
              <>
                {/* Enabled Upload State */}
                <label className="w-100 position-relative">
                  <input
                    className={classes["inputArea"]}
                    style={
                      disableUpload ? { cursor: "no-drop" } : { cursor: "auto" }
                    }
                    type="file"
                    multiple={false}
                    accept=".png,.jpeg,.jpg,.pdf"
                    onChange={(e) => uploadFiles(e.target.files, indent, type)}
                  />
                  <div
                    className="d-flex align-items-center flex-row justify-content-center w-100 position-absolute"
                    style={{ top: "40%" }}
                  >
                    <i className="fa fa-upload px-2" aria-hidden="true"></i>
                    <h5 className={classes["inputText"]}>Upload your {name}</h5>
                  </div>
                </label>
              </>
            )}
          </center>
        </div>
      </div>
      {files?.filter((file) => !file.is_deleted).length > 0 ? (
        <div>
          <span className="row mt-3">
            <span className="col-md-8 font-weight-bold">
              Uploaded File Name
            </span>
            <span className="col-md-2 font-weight-bold">Action</span>
          </span>
          <span className={`${classes["files"]}`}>
            {show ? (
              <div
                style={{ height: "100px" }}
                className="d-flex justify-content-center align-items-center"
              >
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              files?.map((file, idx) => {
                if (!file.is_deleted) {
                  return (
                    <span className="row" key={idx}>
                      <span
                        className="col-md-7"
                        style={{ overflowWrap: "break-word" }}
                      >
                        {file.fileName}
                      </span>
                      <span>
                        <Modal
                          size={"lg"}
                          buttonLabel={
                            <i className="fa fa-eye" aria-hidden="true"></i>
                          }
                          buttonClass="btn btn-sm"
                          content={<ViewFile file={file} />}
                          title={`View`}
                          id="closebutton"
                          screenName="Indents"
                          moduleName="Indent Tracking"
                          activityName="POD/ Invoice View Button Clicked"
                          backdrop={false}
                          style={{ fontSize: "13px" }}
                        />
                      </span>
                      <span>
                        <button className="btn btn-sm">
                          <i
                            className="fa fa-download"
                            onClick={() => handleFileDownload(file)}
                            aria-hidden="true"
                          ></i>
                        </button>
                      </span>
                      <span>
                        <span>
                          {type !== "invoice" && (
                            <Modal
                              buttonLabel={
                                <i
                                  className="fa fa-trash-o"
                                  aria-hidden="true"
                                ></i>
                              }
                              buttonClass="btn btn-sm"
                              title={`Delete Confirmation`}
                              content={({ onClose }) => (
                                <DeleteConfirmationContent
                                  onClose={onClose}
                                  onConfirm={(remarks) =>
                                    removeFile(file, remarks)
                                  }
                                />
                              )}
                              id="deletebutton"
                              screenName="Indents"
                              moduleName="Indent Tracking"
                              activityName="POD/ Invoice Delete Button Clicked"
                              backdrop={true}
                              style={{ fontSize: "13px" }}
                              size="md"
                            />
                          )}
                        </span>
                      </span>
                    </span>
                  );
                }
              })
            )}
          </span>
        </div>
      ) : (
        <center className="mt-3">No files uploaded!</center>
      )}
    </div>
  );
};

export default FileUploadCard;
